const filters = {
  // 医师职称过滤器
  jobTitleFilter(value) {
    switch(parseInt(value)) {
      case 1: return '医师';break;
      case 2: return '住院医师';break;
      case 3: return '主任医师';break;
      case 4: return '副主任医师';break;
      case 5: return '主治医师';break;
      case 6: return '医士';break;
      case 7: return '药士';break;
      case 8: return '药师';break;
      case 9: return '主管药师';break;
      case 10: return '副主任药师';break;
      case 11: return '主任药师';break;
    }
  },
  // 处方类型过滤器
  scriptTypeFilter(value) {
    switch(parseInt(value)) {
      case 1: return '中药饮片';break;
      case 2: return '配方颗粒';break;
      case 3: return '器械耗材';break;
      case 4: return '其它';break;
      case 5: return '西药';break;
      case 6: return '中成药';break;

    }
  },
  // 药房过滤器
  companyFilter(value) {
    switch(parseInt(value)) {
      case 1: return '康美药业';break;
    }
  },
  // 解析Date时间到月
  parseDateToMonth(value) {
    return moment(value).format('YYYY年MM月')
  },
  parseDateToDay(value) {
    return moment(value).format('YYYY年MM月DD日')
  },
  // 性别过滤器
  genderFilter(value) {
    switch(parseInt(value)) {
      case 1: return '男';break;
      case 2: return '女';break;
    }
  },
  // 年龄过滤器
  ageFilter(birthday, type) {
    if(!birthday) return '信息正在加载中...';
    const dataArr = birthday.split('/');
    let year = dataArr[0];
    let month = dataArr[1];
    const currentYear = new Date().getFullYear();
    const currentMonth = new Date().getMonth() + 1;
    let age = currentYear - year;
    if(currentMonth < month) {
      age = (age - 1) >= 0 ? age - 1 : 0;
    }
    if(type == 'number') {
      return `${age}`;
    }else {
      return `${age}岁`;
    }
  },
  // 婚况过滤器
  marriageFilter(value) {
    if(value) {
      switch(parseInt(value)) {
        case 1: return '已婚';break;
        case 2: return '未婚';break;
        default: return '';
      }
    }else {
      return value;
    }
  },
  // 生育情况过滤器
  parentalFilter(value) {
    if(value) {
      switch(parseInt(value)) {
        case 1: return '已育';break;
        case 2: return '未育';break;
        default: return '';
      }
    }else {
      return value;
    }
  },
  // 上传状态过滤器
  uploadStatus(status) {
    switch(status) {
      case 5: return '上传成功';break;
      default: return '上传中';
    }
  },
  // 数字千分位过滤器
  numFormat(value) {
    if (!value) return '0.00';
    let intPart = Number(value).toFixed(0);
    let intPartFormat = intPart.toString().replace(/(\d)(?=(?:\d{3})+$)/g, '$1,');

    let floatPart = ".00";
    let value2Array = value.toString().split(".")
    if(value2Array.length == 2) {
      floatPart = value2Array[1].toString(); //拿到小数部分
      if(floatPart.length == 1) {
        return intPartFormat + "." + floatPart + '0';
      }else {
        return intPartFormat + "." + floatPart;
      }
    }else {
      return intPartFormat + floatPart;
    }
  },
  // 日期过滤器
  dateFilter(stamp, type) {
    switch(type) {
      case 'year':
        return moment.unix(stamp).format('YYYY.MM.DD HH:mm');
        break;
      case 'month':
        return moment.unix(stamp).format('MM.DD HH:mm');
        break;
      case 'day':
        return moment.unix(stamp).format('YYYY.MM.DD');
        break;
      default:
        return moment.unix(stamp).format('YYYY.MM.DD HH:mm');
    }
  },
  // 时间过滤器
  timeFilter(stamp) {
    return moment.unix(stamp).format('HH:mm');
  },
  // 切分数字整数与小数部分
  int(value) {
    if(value == 0) {
      return 0;
    }
    let num = parseFloat(value).toFixed(2);
    num = num.toString();
    return num.substring(0, num.indexOf('.'));

  },
  float(value) {
    if(value == 0) {
      return '.00';
    }
    let num = parseFloat(value).toFixed(2);
    num = num.toString();
    return num.slice(num.indexOf('.'), num.length);
  },
}

export default filters



// WEBPACK FOOTER //
// ./src/untils/filters.js